export const extensionRoutes = [  {
    path: 'extensions/export-orders',
    loadChildren: () => import('./extensions/4dce072cc1558b65db2996baf05b10471e4d2ea364f5b5572aeebb7afbde8c5b/order-export.module').then(m => m.OrderExportModule),
  },
  {
    path: 'extensions/blogs',
    loadChildren: () => import('./extensions/blogs-ui/routes'),
  },
  {
    path: 'extensions/page',
    loadChildren: () => import('./extensions/page/routes'),
  },
  {
    path: 'extensions/page-groups',
    loadChildren: () => import('./extensions/page/groups.routes'),
  },
  {
    path: 'extensions/invoices',
    loadChildren: () => import('./extensions/a9dcc808ddd51c6be0b70eaa57664f2f98b556a7e935815f2c1fc5a2061191cf/invoices.module').then(m => m.InvoicesModule),
  },
  {
    path: 'extensions/invoice-list',
    loadChildren: () => import('./extensions/a9dcc808ddd51c6be0b70eaa57664f2f98b556a7e935815f2c1fc5a2061191cf/routes'),
  },
  {
    path: 'extensions/vendor-registrations',
    loadChildren: () => import('./extensions/seller-registration-ui/routes'),
  },
  {
    path: 'extensions/banners',
    loadChildren: () => import('./extensions/banners/routes'),
  },
  {
    path: 'extensions/newsletter',
    loadChildren: () => import('./extensions/newsletter-ui/routes'),
  },
  {
    path: 'extensions/loyalty-points',
    loadChildren: () => import('./extensions/loyalty-points-ui/routes'),
  },
  {
    path: 'extensions/seller',
    loadChildren: () => import('./extensions/admin-roles-ui/routes'),
  },
  {
    path: 'extensions/barcode',
    loadChildren: () => import('./extensions/barcode-ui/routes'),
  },
  {
    path: 'extensions/bidding-history',
    loadChildren: () => import('./extensions/price-bidding-ui/routes'),
  },
  {
    path: 'extensions/product-reviews',
    loadChildren: () => import('./extensions/dbe409e77e3c92803dca4423de25324d59a57ac068bd86bbf7dd65b13d96482a/routes'),
  },
  {
    path: 'extensions/business-accounts',
    loadChildren: () => import('./extensions/business-account-ui/routes'),
  },
  {
    path: 'extensions/contacts',
    loadChildren: () => import('./extensions/contact-ui/routes'),
  }];
